export const ComingSoonModale = () => {
    return (
        <div>
            Coming soon
        </div>
    )
}